import { jsxs, jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import FlashButton from "../../../atoms/buttons/FlashButton/FlashButton.js";
import FlashButtonContentBrandIcon from "../../../atoms/buttons/FlashButton/FlashButtonContentBrandIcon.js";
import { FlashAppSwitcherAppButtonPrefixes } from "./constants.js";
import { u as useTranslation } from "../../../../useTranslation-cf39c293.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "react";
import "../../../constants.js";
import "../../../../sass/sass.js";
import "../../../atoms/info/FlashBadge/FlashBadge.js";
import "../../../../utils-f8d1c624.js";
import "../../../atoms/info/FlashSpinner/FlashSpinner.js";
import "../../../atoms/buttons/FlashButtonGeneric.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-9f0631d3.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../utils/noOp.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../../utils/invokeFn.js";
import "../../../atoms/buttons/FlashButton/constants.js";
import "../../../atoms/icons/FlashBrandIcon/FlashBrandIcon.js";
import "../../../../i18nInstance-89725fcb.js";
function FlashAppSwitcherNavbarAppButtons(props) {
  const { apps, isActiveApp, onSelect, toggle, logoSize, viewport } = props, { t } = useTranslation(), currentApps = [], pendingApps = [];
  return apps.forEach((app) => {
    app.comingSoon ? pendingApps.push(app) : currentApps.push(app);
  }), /* @__PURE__ */ jsxs("div", { className: "d-flex flex-column pb-flash-200 bg-primary", children: [
    currentApps.map((app) => /* @__PURE__ */ jsx(
      FlashAppSwitcherAppButton,
      {
        app,
        isActiveApp,
        onSelect,
        toggle,
        logoSize,
        viewport
      },
      app.clientType
    )),
    /* @__PURE__ */ jsx("hr", { className: "mt-flash-200 mb-0" }),
    /* @__PURE__ */ jsx("div", { className: "p-flash-200", children: /* @__PURE__ */ jsx("header", { className: "flash-font-heading-m", children: t("APP_SWITCHER:COMING_SOON") }) }),
    pendingApps.map((app) => /* @__PURE__ */ jsx(
      FlashAppSwitcherAppButton,
      {
        app,
        isActiveApp,
        onSelect,
        toggle,
        logoSize,
        viewport
      },
      app.clientType
    ))
  ] });
}
function FlashAppSwitcherAppButton(props) {
  const { app, isActiveApp, onSelect, toggle, logoSize, viewport } = props, isActive = isActiveApp(app), buttonIdPrefix = viewport === "desktop" ? FlashAppSwitcherAppButtonPrefixes.NAVBAR_DESKTOP : FlashAppSwitcherAppButtonPrefixes.NAVBAR_MOBILE;
  return /* @__PURE__ */ jsx("div", { className: classNames("w-100"), children: /* @__PURE__ */ jsx(
    FlashButton,
    {
      id: `${buttonIdPrefix}${app.clientType}`,
      color: "tertiary_subtle",
      isBlock: !0,
      isPressed: isActive,
      align: "start",
      onClick: async () => {
        await onSelect(app), toggle();
      },
      disabled: !app.url,
      className: classNames({ "px-flash-100": viewport === "mobile" }),
      tightRadius: !0,
      children: /* @__PURE__ */ jsx(FlashButtonContentBrandIcon, { brand: { img: app.logo, size: logoSize }, children: /* @__PURE__ */ jsx("span", { className: classNames("d-flex flex-column py-flashd-088"), children: /* @__PURE__ */ jsx(
        "span",
        {
          className: classNames("text-start", {
            "fw-bold": isActive,
            "text-interactive_pressed": isActive
          }),
          children: app.name
        }
      ) }) })
    }
  ) });
}
export {
  FlashAppSwitcherNavbarAppButtons as default
};
//# sourceMappingURL=FlashAppSwitcherNavbarAppButtons.js.map
